import { t } from "i18next";
import moment from "moment-timezone";
import { useEffect, useState } from "react";

import { TrackingEventService } from "../../api/TrackingEventService";
import { useDownloadFiles } from "../../hooks/useDownloadFiles";
import { DownloadIcon2 } from "../../icons/DownloadIcon2/DownloadIcon2";
import { AppointmentTimeTracking } from "../../types/event";
import { formatWorkloadTime } from "../../utils/formatWorkloadTime";

import styles from "./time-tracking-overview.module.css";

interface TimeTrackingOverviewProps {
  appointmentId: string;
}

const formatTime = (date: string | null) => {
  if (!date) return "-";

  return moment(date).tz("Europe/Berlin").format("HH:mm:ss");
};

export const TimeTrackingOverview = ({
  appointmentId,
}: TimeTrackingOverviewProps) => {
  const [timeTrackingData, setTimeTrackingData] =
    useState<AppointmentTimeTracking | null>(null);

  const { fetchDocuments } = useDownloadFiles();

  useEffect(() => {
    if (!appointmentId) return;

    TrackingEventService.GetTimeTrackingTimesheetByAppointment(appointmentId)
      .then((result) => {
        setTimeTrackingData(result.data);
      })
      .catch((error) => console.error(error));
  }, [appointmentId]);

  if (!timeTrackingData) {
    return null;
  }

  return (
    <div className={styles["list"]}>
      <h1 className={styles["list__title"]}>
        <span>{t("Participants")}</span>
        <span>{formatWorkloadTime(timeTrackingData.totalSeconds)}</span>
      </h1>

      <ul>
        {timeTrackingData.technicians.map((technician) => (
          <li key={technician.employeeId}>
            <span>{technician.fullName}</span>
            <span>
              {formatTime(technician.firstStart)} -{" "}
              {formatTime(technician.lastStop)}
              <DownloadIcon2
                handleDownloadButtonClicked={() => {
                  fetchDocuments(technician.employeeId);
                }}
              />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
